// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1bdcc46f8fd5cf90","5405":"c0b8703e7d1ef173","5528":"bb316c81c50a5d4c"}[chunkId] + ".css";
};